<div class="modal-header blue-bg" style="padding:10px !important;">
    <h2 class="modal-title" style="margin:0px !important" id="modal-title">{{_data.title}}</h2>
    <button type="button" class="close" style="color: white;" aria-describedby="modal-title" (click)="modal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p><strong>{{_data.message}}</strong></p>
    </div>
  <div class="modal-footer">
    <button type="button" class="blueBtn" (click)="modal.close(false)">{{_data.cancelBtnText}}</button>
    <button type="button" class="blueBtn" (click)="modal.close(true);">{{_data.confirmBtnText}}</button>
  </div>